import { render, staticRenderFns } from "./NavigationArrow.vue?vue&type=template&id=36ae5592&scoped=true&"
import script from "./NavigationArrow.vue?vue&type=script&lang=js&"
export * from "./NavigationArrow.vue?vue&type=script&lang=js&"
import style0 from "./NavigationArrow.vue?vue&type=style&index=0&id=36ae5592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae5592",
  null
  
)

export default component.exports